import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter, withEnabledBlockingInitialNavigation } from '@angular/router';
import './save-route-before-keycloak';

import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideNativeDateAdapter } from '@angular/material/core';
import { AuthService } from '@core/auth/auth.service';
import { IconsHandler } from '@core/handler/icons.handler';
import { retryInterceptor } from '@core/http/retry.interceptor';
import { authInterceptor } from '@core/http/token.interceptor';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideMarkdown } from 'ngx-markdown';
import { environment } from '../environments/environment';
import { routes } from './app.routes';
export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    // Block bootstrap until Keycloak init completes (keeps initializer flow deterministic)
    provideAppInitializer(() => {
      inject(IconsHandler);
      return inject(AuthService).ensureInit();
    }),
    provideRouter(routes, withEnabledBlockingInitialNavigation()),
    provideHttpClient(withInterceptors([retryInterceptor, authInterceptor])),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: '/i18n/',
        suffix: '.json',
      }),
      fallbackLang: environment.I18N_CONFIG.defaultLocale,
      lang: environment.I18N_CONFIG.appLocale,
    }),
    provideNativeDateAdapter(),
    provideMarkdown(),
  ],
};
